import { api } from "@/api/client";
import type { DiscoveryResult } from "@/types/api";

export async function discoverOdata(): Promise<DiscoveryResult> {
  const { data } = await api.get<DiscoveryResult>("/odata/discovery");
  return data;
}
